import {AllDeviceActivity, StatusDeviceActivity} from "@containers/device/containers/deviceActivity/types";
import {
    getStatusByCalcKeyDeviceActivity
} from "@containers/device/containers/deviceActivity/helpers/getCalcKeyByKeyDeviceActivity";

export const getColorByDeviceActivityStatus = (status:StatusDeviceActivity):string=>{
    switch (status) {
        case "oneHour": {
            return 'yellow'
        }
        case "beforeLastMonth": {
            return 'red'
        }
        case "inactive": {
            return 'gray'
        }
        case "lastMonth": {
            return '#FF3B2F'
        }
        case "lastDay": {
            return '#FFAD3B'
        }
        case "lastWeek": {
            return '#E8672A'
        }
        case "notConnected": {
            return 'black'
        }
        case "online": {
            return '#00D100'
        }
    }
}

export const getColorByDeviceActivityTotalKey = (key:keyof AllDeviceActivity):string=>{
    const status = getStatusByCalcKeyDeviceActivity(key)
    return  getColorByDeviceActivityStatus(status)
}